$(window).on('load', function(){
	// Prevent transitions before DOM ready
	$("body").removeClass("preload");
	$('#cdm-loader').remove();
	if($('.banner').length){
		parallax($('.banner .img-parallax'), $('.banner'));
	}
});	

// Menumobile - http://mmenu.frebsite.nl/
script_on_load('mmenu', function(){
	$('#mmenu').mmenu({
		"slidingSubmenus": false,
		"extensions": [
			"pagedim-black"
		],	
		navbar: {
			title: null
		},
		"offCanvas": {
			"pageSelector": "#page",
			"zposition": 'front',
			"position": 'right'
		},		
		"navbars": [				
			{
				"position": "top",
				"content": [
					$('#home-link-mmenu'),
					"close"
				]
			},
			{
				"position": "bottom",
				"content": [
					$('#topbar .sociaux').clone(),
				]
			}
		],
	});

	$('#mmenu .mm-subopen + a').click(function(e){
		e.preventDefault();
		$(this).prev().trigger('click');
	});

	

	$('#mmenu .search-field').attr('placeholder', '').focusout(function(){
		if($(this).val() !== ''){
			$(this).closest('form').submit();
		}
	});
});

script_on_load('js-owl-carousel', function(){
	var owlPartner = $(".bande_partenaires .owl-carousel");

	// Slider exemple - https://owlcarousel2.github.io/OwlCarousel2/
	owlPartner.owlCarousel({
		items: 5,
		loop: false,
		autoplay: true,
		autoplayTimeout: 5000,
		smartSpeed: 500,
		margin:50,
		responsive: {
			0: {
				items: 2
			},
			380: {
				items: 3
			},
			580: {
				items: 4
			},
			780: {
				items: 5
			},
		},
		center: true
	});
	// Force le recalcule du slider quand une image est loader.
	owlPartner.find('img').one('load lazyloaded', function(){
		owlPartner.trigger('refresh.owl.carousel');
	});
});


	
// Add class desktop si non mobile.
$(window).on('load resize',function() {
	script_on_load('theme-utils', function(){
		if(!isMobile()){
			$('body').addClass('desktop');
		}else{
			$('body').removeClass('desktop');
		}
	});
});

// Le filtre des catégories en ajax
$(function(){
	var loading = false;
	$('.ajax_categories a').click(function(e){
		e.preventDefault();

		if(!loading){

			loading = true;
			
			$('.wrapper-nouvelles').empty();
			$('.content-nouvelles .loader').show();
			$('.content-nouvelles .loader').css('display', 'block');
			$('.content-nouvelles .loader').css('margin', '0 auto');
			$('.content-nouvelles .loader').css('padding-bottom', '40px');
			$('.content-nouvelles .loader').css('max-width', '8%');
	
			var classes = $(this).parent().attr('class');
			classes = classes.split(' ');
			
			for(var i; i>1; i++){
				classes[i];
			}
	
			var id;
			$.each(classes,function(index,val){
				$e = val.split("-");
				if($e[2]){
					id = $e[2];
				}
			});
				data = {
				ajax: true,
				categoryId: id,
				action: 'test'
			}
		
			$.post( phpData.ajax_url, data, function(res){
				JSON.stringify(res);
	
				if(res){
					$('.wrapper-nouvelles').empty();
					$('.ajax_categories a').removeClass('inactif');
					$('.wrapper-nouvelles').append(res);
					$('.content-nouvelles .loader').hide();
					loading = false;
				}
			}, 'json');

		}


	});

	if(!isMobile()){
		$(window).on('scroll load', function(event) {
			if($('.items').length){
				$('.items .item').each(function(i){				
					if($(this).isOnScreen() === true && !($(this).hasClass('completed'))){
						var item  = $(this);
						item.css('opacity',0);
						item.delay(200 * i).animate({opacity:1},700);
						item.addClass('completed').removeClass('item');		
					}
				});	
			}
		});
	}

	/* inscription a l'infolettre */
	$('.infolettre, .newsletter-form').submit(function(e){
		e.preventDefault();

		var messageLog = $(this).find('.error-log');

		if(!validateEmail($(this).find('input[name="email"]').val())){
			messageLog.text(traduction.emailError).removeClass('success').addClass('error').show();
			
		}else{
			// update user interface
			messageLog.html(traduction.emailProcessing).removeClass('success error').show();

			var data = {
				ajax: true,
				email: $(this).find('input[name="email"]').val(),
				lang: phpData.lang,
				action: 'newsletter_subscription'
			}
			
			// Prepare query string and send AJAX request
			$.post( phpData.ajax_url, data, function(res){
				JSON.stringify(res);

				if(res.success){				
					messageLog.removeClass('error').addClass('success').html(res.message);
					
				}else{
					messageLog.removeClass('success').addClass('error').html(res.message);
				}
			}, 'json');
			
			return false;
		}
	});

	// anime les chiffres
    if($('.number-wrapper .number').length){
        $(window).on('scroll load', function() {
            $('.number-wrapper .number').each(function () {
                if(!$(this).hasClass('animated')){
                    if($(this).isOnScreen() == true){
                        var number = $(this).text();

                        $(this).prop('Counter',0).animate({
                            Counter: number
                        }, {
                            duration: 1000,
                            easing: 'swing',
                            step: function () {
								number = Math.ceil(this.Counter);
                                $(this).text(number);
								$(this).addClass("animated");
                            },
                        });
                    }
                }
            });
        });
    }
	
});

$(document).ready(function(){
	$('.tribe-events-button').attr('target', '_blank');
  });

  window.onload = function(){
	var anchors = document.getElementsByClassName('tribe-events-button');
	for (var i=0; i<anchors.length; i++){
	  anchors[i].setAttribute('target', '_blank');
	}
  }

window.onscroll = function() {scrollFunction()};

function scrollFunction() {
  if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
    document.getElementById("goTop").style.display = "block";
  } else {
    document.getElementById("goTop").style.display = "none";
  }

}

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}

// Fermeture de popup
$(function(){
	$('#popup-overlay, .close-popup, .popup .popup-content a').on('click', function(e){
		closePopups();
	});
});

// Popup de visite
$(window).on('load', function(){
	if($('#popup-general').length && !sessionStorage.getItem('onloadpopup')){
		openPopup($('#popup-general'));

		$('#popup-general').on('popupClosed', function(){
			sessionStorage.setItem('onloadpopup', true);
		});
	}
});


function openPopup(popup){
	if(!$('.popup.visible').length){ // si un popup est déjà ouvert, on ne fait rien.
		$(popup).addClass('visible');
		$('#popup-overlay').addClass('visible');
	}
}

function closePopups(){
	$('.popup.visible').each(function(){
		$(this).removeClass('visible');
		
		this.dispatchEvent(new CustomEvent('popupClosed'));
	});
	
	$('#popup-overlay').removeClass('visible');
}